"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToString = void 0;
class ToString {
    convert(str) {
        if (str.trim() === '')
            return undefined;
        return str;
    }
}
exports.ToString = ToString;
//# sourceMappingURL=to-string.js.map